import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { IpkgDestCat } from "../../../types/global";
import PkgDestCategoryService from "../../../services/PkgDestCategory.service";
import LangContext from "../../../context/LangContext";

const FeaturedCategories = () => {
  const [data, setData] = useState<IpkgDestCat[]>([]);
  const { lang_id } = useContext(LangContext);
  const fetchFeaturedCat = async (lang: string) => {
    try {
      const res = await PkgDestCategoryService.fetchCategories(
        `?lang_id=${lang_id}&isFeatured=true`
      );
      console.log(res, "ress===>>>>");
      setData(res.data.data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (lang_id) {
      fetchFeaturedCat(lang_id);
    }
    // fetchFeaturedCat();
  }, [lang_id]);
  return (
    <div className="bg-gray-100 pt-[5%] pb-[10%]">
      <div className="container mx-auto px-4 text-center">
        <div className="  w-full ">
          <div className="prose mx-auto">
            <h1 className="uppercase">Top trekking au Népal</h1>
          </div>
          <hr className="mt-8" />
        </div>
        <div className="mt-24 w-3/4  mx-auto">
          {data.map((item, i) => (
            <div key={item.id}>
              <div className="flex flex-col md:flow-row items-start gap-8">
                <img
                  src={`${process.env.REACT_APP_API}/uploads/images/${item.img}`}
                  alt=""
                  className="w-1/3 h-full"
                />
                <div className="prose col-span-8 text-left">
                  <h2>{item.translations[0].category_title}</h2>
                  <div
                    className="prose"
                    dangerouslySetInnerHTML={{
                      __html: item.translations[0].description,
                    }}
                  ></div>
                  <Link
                    to={
                      item.package_type === "global"
                        ? `/trek-au-nepal?pkgCategory=${item.id}`
                        : `/local-packages?pkgCategory=${item.id}`
                    }
                  >
                    <span className="text-blue-500">Read more ..</span>
                  </Link>
                </div>
              </div>
              <hr className="my-4 shadow-sm" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FeaturedCategories;
